import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { RecoilState, SetterOrUpdater, useRecoilState } from "recoil";

export const useDebouncedState = <T>(
  recoilState: RecoilState<T>,
  delay = 100
): [T, SetterOrUpdater<T>] => {
  const [state, setState] = useRecoilState(recoilState);

  const [_state, setLocalState] = useState(state);
  const [debouncedState] = useDebounce(_state, delay);

  useEffect(() => {
    state !== debouncedState && setState(debouncedState);
  }, [debouncedState]);

  useEffect(() => {
    state !== _state && setLocalState(state);
  }, [state]);

  return [_state, setLocalState];
};
